import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg';

interface IconAiContentProps {
  size?: number;
}

export const IconAiContent = ({ size = 24 }: IconAiContentProps) => {
  return (
    <Svg width={size} height={size} viewBox="-4.4 -4.7 24 24" fill="none">
      <Path
        d="M3.5729 11.1815C3.50607 11.0373 3.38945 10.922 3.24447 10.8569L0.389628 9.57426C-0.129876 9.34085 -0.129876 8.60326 0.389628 8.36985L3.24447 7.0872C3.38945 7.02206 3.50607 6.9068 3.5729 6.76259L4.88717 3.9267C5.12358 3.41657 5.84874 3.41657 6.08515 3.9267L7.39942 6.76259C7.46625 6.9068 7.58287 7.02206 7.72785 7.0872L10.5827 8.36985C11.1022 8.60326 11.1022 9.34085 10.5827 9.57426L7.72785 10.8569C7.58287 10.922 7.46625 11.0373 7.39942 11.1815L6.08515 14.0174C5.84874 14.5275 5.12358 14.5275 4.88716 14.0174L3.5729 11.1815ZM10.5827 1.77303C10.516 1.91584 10.4004 2.03007 10.2568 2.09508L8.86809 2.72387C8.35091 2.95803 8.35091 3.69253 8.86809 3.9267L10.2568 4.55549C10.4004 4.6205 10.516 4.73473 10.5827 4.87753L11.2329 6.26974C11.47 6.77751 12.1921 6.77751 12.4292 6.26974L13.0794 4.87753C13.1461 4.73473 13.2617 4.6205 13.4053 4.55549L14.794 3.9267C15.3112 3.69253 15.3112 2.95803 14.794 2.72387L13.4053 2.09508C13.2617 2.03007 13.1461 1.91584 13.0794 1.77303L12.4292 0.380823C12.1921 -0.126941 11.47 -0.126941 11.2329 0.380823L10.5827 1.77303Z"
        fill="url(#paint0_linear_ai_content)"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_ai_content"
          x1="13.329"
          y1="14.4"
          x2="0.714335"
          y2="14.0034"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#772EED" />
          <Stop offset="1" stopColor="#3478FF" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};
